import { inviteCodeSchema, usernameSchema } from '../utils/schema';
import { ApiInstance } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';
import useDebounce from 'ahooks/lib/useDebounce';
import { useMemo } from 'react';

export const useCheckUserInfo = (api: ApiInstance, name: string, inviteCode: string) => {
  const isName = useMemo(() => usernameSchema.safeParse(name).success, [name]);
  const isInviteCode = useMemo(() => inviteCodeSchema.safeParse(inviteCode).success, [inviteCode]);
  const debounceName = useDebounce(name, { wait: 500 });
  const debounceInviteCode = useDebounce(inviteCode, { wait: 500 });
  return useQuery({
    enabled: (isName && !!debounceName) || (isInviteCode && !!debounceInviteCode),
    refetchInterval: false,
    queryKey: ['CheckUserInfo', isName, isInviteCode, debounceName, debounceInviteCode],
    queryFn: async ({ signal }) => {
      const [{ data: nameInfo }, { data: codeInfo }] = await Promise.all([
        debounceName
          ? api.user.getUserInfo({ name: debounceName }, { signal }).catch(() => ({ data: undefined }))
          : { data: undefined },
        debounceInviteCode
          ? api.user.getUserInfo({ inviteCode: debounceInviteCode }, { signal }).catch(() => ({ data: undefined }))
          : { data: undefined },
      ]);
      return {
        nameInfo,
        codeInfo,
      };
    },
  });
};
